import { FullBillFragment } from '../../../graphql/generated/graphql'
import { formatCurrency } from '../../../utils/format'

export const useBillDetails = (bill: FullBillFragment) => {
    const hasNoBalance = bill.balance === null
    const balance = bill.balance !== null ? formatCurrency(bill.balance) : null
    const amountDue = bill.amountDue !== null ? formatCurrency(bill.amountDue) : null
    const paymentDate = bill.nextPaymentDueDate ?? null

    return {
        balance,
        amountDue,
        paymentDate,
        hasNoBalance,
    }
}
